export const createImage = (file) => {
    const reader = new FileReader()
    return new Promise((resolve) => {
      reader.onload = (e) => {
        resolve({uri: e.target.result, file})
      }
      reader.readAsDataURL(file)
    })
  }